import Request from '../Request.utils'
export interface ISyncAllRequestBody {
  batchSize?: number;
  retryAttempts?: number;
}
export interface ISyncDocumentRequestBody {
  documentNo: string;
  retryAttempts?: number;
}
export interface IDumpImportRequestBody {
  batchSize?: number;
  includeData?: boolean;
  memoryOptimized?: boolean;
  outputDir?: string;
  verifyImport?: boolean;
}
export interface IDumpImportJSONRequestBody {
  batchSize?: number;
  forceReExport?: boolean;
  includeData?: boolean;
  memoryOptimized?: boolean;
  outputDir?: string;
  verifyImport?: boolean;
}
export interface IDumpStatusRequestQuery {
  outputDir?: string;
}
export interface IDownloadDumpRequestQuery {
  filename: string;
  outputDir?: string;
}


class MysqlSyncAPI {
  status = async () => {
    const res = await Request.call('/api/mysql-sync/status', 'GET', undefined, undefined, undefined, );
    return res;
  }
  syncAll = async (body: ISyncAllRequestBody) => {
    const res = await Request.call('/api/mysql-sync/sync-all', 'POST', undefined, undefined, body, );
    return res;
  }
  syncDocument = async (body: ISyncDocumentRequestBody) => {
    const res = await Request.call('/api/mysql-sync/sync-document', 'POST', undefined, undefined, body, );
    return res;
  }
  dumpImport = async (body: IDumpImportRequestBody) => {
    const res = await Request.call('/api/mysql-sync/dump-import', 'POST', undefined, undefined, body, );
    return res;
  }
  dumpImportJSON = async (body: IDumpImportJSONRequestBody) => {
    const res = await Request.call('/api/mysql-sync/dump-import-json', 'POST', undefined, undefined, body, );
    return res;
  }
  dumpStatus = async (query: IDumpStatusRequestQuery) => {
    const res = await Request.call('/api/mysql-sync/dump-status', 'GET', undefined, query, undefined, );
    return res;
  }
  downloadDump = async (query: IDownloadDumpRequestQuery) => {
    const res = await Request.call('/api/mysql-sync/download-dump', 'GET', undefined, query, undefined, );
    return res;
  }
}
export default new MysqlSyncAPI()